// removed by extract-text-webpack-plugin
module.exports = {"section":"_2R9HUICcFGXARsts-Uo5Xv","instructions":"_1JcDO7I3JZkYTVjKBB3VX0","text":"_1fIvf-W38_e1eoMlZUL69C","view":"_8JbZqru9d1UeTyfU56mlb","image":"_35Mw2aQgujQHuXEcKCuoX3","imageContainer":"_13HhJWGFW2WjGG49T_rMce"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/MassiveDactilar/Instructions/styles.css
// module id = 2744
// module chunks = 0